export { FastshiftCustomerSelectionPage } from './src/fastshift-customer-selection';
